/* CreateFolderAction.js */

"use strict";
const CreateFolderComponent = require("./CreateFolderComponent");

class CreateFolderAction {
    constructor(logger, gameEditor, modalUserFeedback, OsImagePaths, userSession, activeView) {
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._osImagePathsEntity = OsImagePaths;
        this._activeOrgId = userSession.activeOrganization.id;
        this._modalUserFeedback = modalUserFeedback;
        this._activeView = activeView;
        this._parentPathId = this._activeView.getSelectedPath();

        this.run = this.run.bind(this);
    }
    run() {
        if (!this._activeView.canEditFolders()) {
            return Promise.resolve();
        }
        return this._modalUserFeedback
            .displayCustom(new CreateFolderComponent(this._logger), {dontHide: true})
            .then((result) => this._createFolder(result.trim()))
            .catch((error) => {
                if (error && !error.userRejected) {
                    this._logger.warn({error}, "CreateFolderAction.run()");
                    return this._modalUserFeedback.displayError(error);
                }
            })
            .then(() => this._modalUserFeedback.hideDisplayed());
    }
    /* jshint ignore:start */
    async _createFolder(name) {
        let osip = await this._osImagePathsEntity.loadPaths(this._activeOrgId);
        if (osip) {
            osip.createPath(name, this._parentPathId || null);
            return await osip.update();
        } else {
            let osPath = new this._osImagePathsEntity(this._activeOrgId);
            osPath.createPath(name, null);
            return await osPath.create();
        }
    }
    /* jshint ignore:end */
}
module.exports = CreateFolderAction;

CreateFolderAction.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.ui.userFeedback",
    "$teve.entities.OsImagePaths",
    "$teve.userSession",
    "gameEditor.activeView",
];

CreateFolderAction.$displayDetails = {
    type: "Action",
    name: "CreateAction",
    icon: "fileserver.add_folder",
    shown: true,
    title: "Add Folder",
    order: 1,
};
